// packages/core/src/learning/schools/index.ts
// ─────────────────────────────────────────────────────────────────────────
// Registry: imports every per-school exhibit file and assembles the
// SCHOOL_EXHIBITS map consumed by ../SchoolExhibitMeta.ts.
//
// To add / wire a school: drop its file in this folder, then add ONE import
// line + ONE map entry below. (Mirrors LearningData.ts batch assembly.)
//
// Stubs are included so the validator surfaces the full "to author" list as
// warnings. A stub renders best-effort and falls back to the lean SchoolMeta
// view; it never blocks. Authoring = fill the file + bump its revision to 1.
// ─────────────────────────────────────────────────────────────────────────

import type { ListedSchool } from '../LearningTypes';
import type { SchoolExhibitEntry } from '../SchoolExhibitMeta';

import { CREDIT_OPTIMIZATION_EXHIBIT } from './credit-optimization';
import { TAX_OPTIMIZATION_EXHIBIT } from './tax-optimization';
import { ANTI_SCAM_EXHIBIT } from './anti-scam';
import { RISK_MANAGEMENT_EXHIBIT } from './risk-management';
import { ADULTING_LIFE_SKILLS_EXHIBIT } from './adulting-life-skills';
import { FINTECH_AUTOMATION_EXHIBIT } from './fintech-automation';
import { BEHAVIORAL_FINANCE_EXHIBIT } from './behavioral-finance';
import { MONEY_PSYCHOLOGY_HOUSEL_EXHIBIT } from './money-psychology-housel';
import { EFFICIENT_MARKET_EXHIBIT } from './efficient-market';
import { REAL_RETURN_EXHIBIT } from './real-return';
import { DEBT_FREE_RAMSEY_EXHIBIT } from './debt-free-ramsey';
import { BOGLEHEAD_INDEXING_EXHIBIT } from './boglehead-indexing';
import { VALUE_INVESTING_EXHIBIT } from './value-investing';
import { FACTOR_INVESTING_EXHIBIT } from './factor-investing';
import { DIVIDEND_INVESTING_EXHIBIT } from './dividend-investing';
import { GROWTH_INVESTING_EXHIBIT } from './growth-investing';
import { BUFFETT_MUNGER_EXHIBIT } from './buffett-munger';
import { CASHFLOW_ASSETS_EXHIBIT } from './cashflow-assets';
import { TECHNICAL_TRADING_EXHIBIT } from './technical-trading';
import { OPTIONS_DERIVATIVES_EXHIBIT } from './options-derivatives';
import { CRYPTO_WEB3_EXHIBIT } from './crypto-web3';
import { FIRE_MOVEMENT_EXHIBIT } from './fire-movement';
import { FI_MATH_EXHIBIT } from './fi-math';
import { COAST_FI_SLOW_FI_EXHIBIT } from './coast-fi-slow-fi';
import { FIRST_100K_EXHIBIT } from './first-100k';
import { MINIMALISM_EXHIBIT } from './minimalism';
import { FRUGALITY_EXHIBIT } from './frugality';
import { RICH_LIFE_RAMIT_EXHIBIT } from './rich-life-ramit';
import { LIFE_DESIGN_EXHIBIT } from './life-design';
import { INCOME_EXPANSION_EXHIBIT } from './income-expansion';
import { CAREER_CAPITAL_EXHIBIT } from './career-capital';
import { HUMAN_CAPITAL_EXHIBIT } from './human-capital';
import { REAL_ESTATE_HOUSING_EXHIBIT } from './real-estate-housing';
import { RELATIONSHIP_FAMILY_MONEY_EXHIBIT } from './relationship-family-money';
import { MACRO_MONEY_EXHIBIT } from './macro-money';
import { HARD_MONEY_EXHIBIT } from './hard-money';
import { KEYNESIAN_MMT_EXHIBIT } from './keynesian-mmt';
import { INEQUALITY_AWARENESS_EXHIBIT } from './inequality-awareness';
import { ANTI_FRAGILITY_EXHIBIT } from './anti-fragility';

export const SCHOOL_EXHIBITS: Partial<
	Record<ListedSchool, SchoolExhibitEntry>
> = {
	'credit-optimization': CREDIT_OPTIMIZATION_EXHIBIT,
	'tax-optimization': TAX_OPTIMIZATION_EXHIBIT,
	'anti-scam': ANTI_SCAM_EXHIBIT,
	'risk-management': RISK_MANAGEMENT_EXHIBIT,
	'adulting-life-skills': ADULTING_LIFE_SKILLS_EXHIBIT,
	'fintech-automation': FINTECH_AUTOMATION_EXHIBIT,
	'behavioral-finance': BEHAVIORAL_FINANCE_EXHIBIT,
	'money-psychology-housel': MONEY_PSYCHOLOGY_HOUSEL_EXHIBIT,
	'efficient-market': EFFICIENT_MARKET_EXHIBIT,
	'real-return': REAL_RETURN_EXHIBIT,
	'debt-free-ramsey': DEBT_FREE_RAMSEY_EXHIBIT,
	'boglehead-indexing': BOGLEHEAD_INDEXING_EXHIBIT,
	'value-investing': VALUE_INVESTING_EXHIBIT,
	'factor-investing': FACTOR_INVESTING_EXHIBIT,
	'dividend-investing': DIVIDEND_INVESTING_EXHIBIT,
	'growth-investing': GROWTH_INVESTING_EXHIBIT,
	'buffett-munger': BUFFETT_MUNGER_EXHIBIT,
	'cashflow-assets': CASHFLOW_ASSETS_EXHIBIT,
	'technical-trading': TECHNICAL_TRADING_EXHIBIT,
	'options-derivatives': OPTIONS_DERIVATIVES_EXHIBIT,
	'crypto-web3': CRYPTO_WEB3_EXHIBIT,
	'fire-movement': FIRE_MOVEMENT_EXHIBIT,
	'fi-math': FI_MATH_EXHIBIT,
	'coast-fi-slow-fi': COAST_FI_SLOW_FI_EXHIBIT,
	'first-100k': FIRST_100K_EXHIBIT,
	minimalism: MINIMALISM_EXHIBIT,
	frugality: FRUGALITY_EXHIBIT,
	'rich-life-ramit': RICH_LIFE_RAMIT_EXHIBIT,
	'life-design': LIFE_DESIGN_EXHIBIT,
	'income-expansion': INCOME_EXPANSION_EXHIBIT,
	'career-capital': CAREER_CAPITAL_EXHIBIT,
	'human-capital': HUMAN_CAPITAL_EXHIBIT,
	'real-estate-housing': REAL_ESTATE_HOUSING_EXHIBIT,
	'relationship-family-money': RELATIONSHIP_FAMILY_MONEY_EXHIBIT,
	'macro-money': MACRO_MONEY_EXHIBIT,
	'hard-money': HARD_MONEY_EXHIBIT,
	'keynesian-mmt': KEYNESIAN_MMT_EXHIBIT,
	'inequality-awareness': INEQUALITY_AWARENESS_EXHIBIT,
	'anti-fragility': ANTI_FRAGILITY_EXHIBIT,
};
